import React from 'react';
import PropTypes from 'prop-types';
import MUIDataTable from 'mui-datatables';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { Loader } from 'ui';
import { DatatableStyledWrapper } from './DatatablePreview.styled';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    width: '100%',
  },
}));

const DatatablePreview = ({ columns, data, loading, onViewAllClick }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const options = {
    pagination: false,
    selectableRows: 'none',
    filter: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    elevation: 0,
  };

  return (
    <DatatableStyledWrapper className={classes.root}>
      {loading && <Loader cover />}
      <MUIDataTable columns={columns} data={data} options={options} />
      {onViewAllClick && (
        <Box py={2}>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" onClick={onViewAllClick}>
                {t('View all')}
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </DatatableStyledWrapper>
  );
};

DatatablePreview.defaultProps = {
  loading: false,
  onViewAllClick: false,
};

DatatablePreview.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])).isRequired,
  data: PropTypes.arrayOf(PropTypes.array.isRequired).isRequired,
  loading: PropTypes.bool,
  onViewAllClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

export default DatatablePreview;
